import { render, staticRenderFns } from "./InlineAddress.vue?vue&type=template&id=36c52dde&"
import script from "./InlineAddress.vue?vue&type=script&lang=ts&"
export * from "./InlineAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports